import React, { useCallback, useEffect, useState } from "react";

import { Button } from "semantic-ui-react";
import swal from "sweetalert";

import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";
import Footer from "../../../components/Footer";

import { producaov2 as api } from "../../../services/apis";

import { Container, Header } from "./styles";

const RelatorioInscricoes = () => {
  document.title = "Painel Administrativo | Grupo Voitto";

  const [dataInicio, setDataInicio] = useState(new Date());
  const [dataFinal, setDataFinal] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const [relatorio, setRelatorio] = useState(false);
  const [inscricoes, setInscricoes] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);

  const handleGenerateReport = useCallback(() => {
    setLoading(true);
    setRelatorio(false);

    api
      .post("admin/relatorio-inscricao", {
        data_inicio: dataInicio,
        data_final: dataFinal,
      })
      .then((res) => {
        setRelatorio(res.data.response);
        setLoading(false);

        const acao = JSON.stringify({
          local: "Relatorio",
          texto: `Gerou o relatorio entre ${dataInicio} e ${dataFinal}}`,
        });

        api.post("system_logs", { acao });
        swal("Confirmado!", "Relatório gerado com sucesso", "success");

        window.open(res.data.response, "blank");
      })
      .catch((error) => {
        setLoading(false);
        if (!error.response) {
          return;
        }

        swal(`Algo deu errado`, `Se persistir, contate nosso suporte`, "error");
      });
  }, [dataInicio, dataFinal, swal]);

  const handleChange = (event, value) => {
    setPage(value);
  };

  const getInscricoes = useCallback(() => {
    if (!dataInicio || !dataFinal) {
      return;
    }

    const params = {
      page: page || 1,
      data_inicio: dataInicio,
      data_final: dataFinal,
    };

    api
      .get("admin/relatorio-inscricao", { params })
      .then((res) => {
        setInscricoes(res.data.response.dados);
        setPage(res.data.response.page);
        setTotal(res.data.response.total);
      })
      .catch((err) => console.error(err));
  }, [page, dataInicio, dataFinal]);

  return (
    <>
      <AdminMenu />
      <Header>Relatórios</Header>
      <Container>
        <Button onClick={() => window.open("/admin/relatorios/inscricoes")}>
          Inscrições
        </Button>

        <Button
          onClick={() => window.open("/admin/relatorios/pagamentos-futuros")}
        >
          Pagamentos Futuros
        </Button>

        <Button onClick={() => window.open("/admin/relatorios/inadimplentes")}>
          Inadimplentes
        </Button>

        <Button
          onClick={() => window.open("/admin/relatorios/inadimplentes/boleto")}
        >
          Inadimplentes Boleto
        </Button>

        <Button onClick={() => window.open("/admin/relatorios/pesquisa")}>
          NPS Cursos
        </Button>
        <Button onClick={() => window.open("/admin/relatorios/pesquisa-mba")}>
          NPS MBA
        </Button>
        <Button
          onClick={() => window.open("/admin/relatorios/inscricoes/minificado")}
        >
          Inscrições pagas
        </Button>

        <Button onClick={() => window.open("/admin/operacoes")}>
          Operações
        </Button>

        {/* <Button onClick={() => window.open("/admin/relatorios/espera")}>
          Lista de Espera
        </Button> */}

        <Button onClick={() => window.open("/admin/relatorios/subitens")}>
          Subitens (Certificados e Materiais)
        </Button>

        <Button
          onClick={() => window.open("/admin/relatorios/pacotes-vendidos")}
        >
          Pacotes vendidos
        </Button>

        <Button onClick={() => window.open("/admin/relatorios/mba")}>
          Matrículas MBA
        </Button>

        <Button onClick={() => window.open("/admin/relatorios/progresso/mba")}>
          Progressos MBA
        </Button>

        <Button
          onClick={() => window.open("/admin/relatorios/close-to-expiring")}
        >
          Próximos do Vencimento
        </Button>
        <Button
          onClick={() => window.open("/admin/relatorios/alunos-mba")}
        >
          Alunos MBA
        </Button>
      </Container>
      <Footer />
    </>
  );
};

export default RelatorioInscricoes;
